import { make } from 'vuex-pathify'
import repository from '../../apis/repository'

function getSundayAndSaturday() {
	const today = new Date()
	const dayOfWeek = today.getDay() // 0 = Sunday, 1 = Monday, etc.

	const sunday = new Date(today)
	sunday.setDate(today.getDate() - dayOfWeek)

	const saturday = new Date(today)
	saturday.setDate(today.getDate() + (6 - dayOfWeek))

	const format = date => {
		const year = date.getFullYear()
		const month = String(date.getMonth() + 1).padStart(2, '0')
		const day = String(date.getDate()).padStart(2, '0')

		return `${year}-${month}-${day}`
	}

	return [format(sunday), format(saturday)]
}

const [defaultStart, defaultEnd] = getSundayAndSaturday()

const state = {
	totalItems: 0,
	items: [],
	options: {},
	search: '',
	startDate: defaultStart,
	endDate: defaultEnd,
	storeCode: '',
	pointsTargetFilter: 'above',
}

const getters = make.getters(state)
const mutations = make.mutations(state)

const actions = {
	async datatable({ commit }) {
		const {
			options,
			search,
			startDate,
			endDate,
			storeCode,
			pointsTargetFilter,
		} = state
		const { data } = await repository.points.datatable({
			...options,
			search,
			start_date: startDate,
			end_date: endDate,
			store_code: storeCode,
			points_target_filter: pointsTargetFilter,
		})
		commit('SET_ITEMS', data.data)
		commit('SET_TOTAL_ITEMS', data.total)

		return data.data
	},
	async exportData() {
		const {
			options,
			search,
			startDate,
			endDate,
			storeCode,
			pointsTargetFilter,
		} = state
		const { data } = await repository.points.export({
			...options,
			search,
			start_date: startDate,
			end_date: endDate,
			store_code: storeCode,
			points_target_filter: pointsTargetFilter,
		})

		let csvContent = 'data:text/csv;charset=utf-8,\uFEFF'
		const headers = ['Customer ID', 'Customer Name', 'Phone Number', 'Transaction Count', 'Total Points', 'Total Amount Spent']
		const rows = data.map(item => [
			item.customer_id,
			item.customer_name,
			`'${item.phone_number}`,
			item.transaction_count,
			item.total_points,
			item.total_amount_spent,
		])

		csvContent += [headers, ...rows]
			.map(row => row.map(val => `"${String(val).replace(/"/g, '""')}"`).join(','))
			.join('\n')

		const encodedUri = encodeURI(csvContent)
		const link = document.createElement('a')
		link.setAttribute('href', encodedUri)
		link.setAttribute('download', 'reward_points.csv')
		document.body.appendChild(link)
		link.click()
		document.body.removeChild(link)
	},
}

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
}
